
import {makeStyles} from "@material-ui/core";
import {themeTypeToBool} from '../../../utils/helpers';

export default makeStyles(theme => ({
    container: {
        background: theme.palette.background.paper,
        margin: theme.spacing(1),
        padding: theme.spacing(2),
    },
    tableHeader: {
        background: themeTypeToBool(theme.palette.type) ? theme.palette.background.default : theme.palette.background.paper,
    },
    row: {
        cursor: "pointer",
    },
    cell: {
        textAlign: "center",
    }
}));